import * as moment from "moment";
import DateUtils from "sh-application/utility/DateUtils";
import { ConflictStore } from "sh-conflict-store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_CONFLICT_STORE_DATE_RANGE', function setConflictStoreDateRange(startTime: moment.Moment, endTime: moment.Moment) {
   ConflictStore().startTime = DateUtils.getStartOfDay(startTime);
   ConflictStore().endTime = DateUtils.getStartOfDay(endTime);
});
